import React, { useEffect } from 'react'

const COMMENT_CONTAINER_SELECTOR = '.comment__body__container'
const LATEST_DRAFT_SELECTOR = '[data-latest-draft="true"]'

/** Allows Rails-rendered DOM to stabilize before React queries it. */
export const SCROLL_DELAY_MS = 100

const AutoScrollToAiDraft: React.FC = () => {
  useEffect(() => {
    const performAutoScroll = () => {
      const anchorElement = document.querySelector<HTMLElement>(LATEST_DRAFT_SELECTOR)

      if (!anchorElement) {
        return
      }

      const commentContainer = anchorElement.closest<HTMLElement>(COMMENT_CONTAINER_SELECTOR)

      if (!commentContainer) {
        return
      }

      const isVisible = checkElementVisibility(commentContainer)

      if (!isVisible) {
        commentContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }

    const checkElementVisibility = (element: HTMLElement): boolean => {
      const rect = element.getBoundingClientRect()
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight

      return rect.top < viewportHeight && rect.bottom > 0
    }

    const scrollDelayTimeout = setTimeout(() => {
      performAutoScroll()
    }, SCROLL_DELAY_MS)

    return () => {
      clearTimeout(scrollDelayTimeout)
    }
  }, [])

  return null
}

export default AutoScrollToAiDraft
